import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';
import { Colors, Text } from '@mercator-gcp/grout';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { FlexRow } from 'components/layout/FlexRow';

const detailGridStyle = {
  rowGap: 'padding_16',
};

type TDetailGridProps = {
  sx?: BoxProps['sx'];
  children?: BoxProps['children'];
};

export const DetailGrid = ({ sx, children }: TDetailGridProps) => {
  return <FlexColumn sx={{ ...detailGridStyle, ...sx }}>{children}</FlexColumn>;
};

const detailSectionStyle = {
  display: 'inline-flex',
  width: '100%',
  justifyContent: 'normal',
  columnGap: 'padding_8',
};

const sectionContentStyle = {
  flex: 1,
  alignItems: 'start',
};

const labelStyle = {
  width: '130px',
};

type SectionProps = {
  title?: string;
  titleOverride?: React.ReactNode;
  children: React.ReactNode;
  labelStyleOverride?: BoxProps['sx'];
} & BoxProps;

const SectionComponent = ({
  title,
  children,
  titleOverride,
  labelStyleOverride,
}: SectionProps) => (
  <section aria-label={title}>
    <FlexRow sx={detailSectionStyle}>
      {titleOverride ? (
        <Box as="label" sx={labelStyleOverride || labelStyle}>
          {titleOverride}
        </Box>
      ) : (
        <Text.SmallLabel color={Colors.TextQuiet} sx={labelStyleOverride || labelStyle}>
          {title}
        </Text.SmallLabel>
      )}
      <Box sx={sectionContentStyle}>{children}</Box>
    </FlexRow>
  </section>
);

DetailGrid.Section = SectionComponent;
